export const defaultState = () => ({
  user: null,
  isManager: false,
  hasManagerRole: false,
  title: null,
  season: null,
  chapterId: null,
  selectedCategoryId: null,
  loadedChapters: [],
  tabId: null,
  entry: null,
  tabs: [],
  fields: [],
  contributors: {},
  attachments: null,
  updatedAt: null,
  values: {
    Attachments: {},
    Entries: {},
    Contributors: {}
  },
  conditionalVisibility: {
    Attachments: {},
    Entries: {},
    Contributors: {}
  },
  status: { status: 'ok', message: '' },
  chapters: [],
  tabsLoaded: false,
  fieldsLoaded: false,
  chaptersLoaded: false,
  attachmentsLoaded: false,
  contributorsLoaded: false,
  uploaderStatus: {},
  uploadInProgress: false,
  locks: {
    lockedCategory: false,
    readOnly: false
  },
  sponsorsEnabled: false,
  links: [],
  formHash: null,
  errors: {},
  tabFieldsErrors: {},
  tabApiErrors: [],
  tempFiles: [],
  fieldGuideUrl: null,
  categories: [],
  plagiarismDetection: false,
  searchableFields: [],
  fieldTypes: [],
  fieldCompatibility: {},
  conditionalFieldTypes: [],
  conditionals: {},
  protectionTypes: [],
  protectionGuideUrl: null,
  fieldTemplate: {},
  fileTypes: {},
  tableFieldConfiguratorLabels: {},
  tableFieldInputTypes: [],
  tabTemplate: {},
  tabTypes: [],
  contentBlocks: [],
  categoryTemplate: {},
  categoryMergeFields: [],
  scoreSets: [],
  attachmentTypes: {},
  chapterManagers: [],
  chapterTemplate: {},
  isAtChapterLimit: false,
  canConfigureCategories: false,
  canConfigureChapters: false,
  awaitingPayment: false
});

const state = defaultState();

export default state;
